import React from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseView } from '@/components/base'
import { ScanQRCode } from '@/components/ScanQRCode'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'
import { useWithdrawStore } from '@/store/useWithdrawStore'

export const WithdrawScanWalletAddressScreen: React.FC = () => {
  const navigate = useNavigate()
  const setWalletAddressRegisterForm = useWithdrawStore(
    (state) => state.setWalletAddressRegisterForm,
  )

  const handleScan = (address: string) => {
    // Save scanned address to store
    setWalletAddressRegisterForm({ address })

    // Navigate back to address registration page with a small delay
    setTimeout(() => {
      navigate('/withdraw/register-wallet-address', { replace: true })
    }, 200)
  }

  const handleRejectCameraPermission = () => {
    // Navigate back if user denied permission
    navigate(-1)
  }

  return (
    <>
      {/* Fixed Header Navigation without background */}
      <StickyHeaderNavigation showBackButton={true} showBackground={false} />

      {/* Full-screen content with scanner */}
      <BaseView
        flex={1}
        center
        justify="center"
        bgColor="background.screen"
        data-component="withdraw-scan-wallet-address-screen"
      >
        <ScanQRCode
          onScanResult={handleScan}
          onRejectPermission={handleRejectCameraPermission}
        />
      </BaseView>
    </>
  )
}
